'use client'

import PremiumTag from '@/app/[locale]/[roomId]/components/PremiumTag'
import WorldInfoCreator from '@/app/[locale]/[roomId]/components/WorldInfoCreator'
import WorldInfoDetails from '@/app/[locale]/[roomId]/components/WorldInfoDetails'
import WorldInfoTitle from '@/app/[locale]/[roomId]/components/WorldInfoTitle'
import WorldPlayButtonMobile from '@/app/[locale]/[roomId]/components/WorldPlayButtonMobile'
import { useCheckEnterRoomContext } from '@/context/CheckEnterRoomContext'
import { useUAContext } from '@/context/UAContext'

function WorldInfoPanel() {
  const { isMobileLandscape } = useUAContext()
  const { isPremiumRoom } = useCheckEnterRoomContext()

  return (
    <div className={'flex flex-col gap-4'}>
      <div className="flex flex-col gap-2">
        {isPremiumRoom && (
          <PremiumTag className="border-vive-primary-70 border-[1.5px] bg-transparent" />
        )}
        <WorldInfoTitle />
      </div>
      <WorldPlayButtonMobile />
      <WorldInfoCreator />
      {isMobileLandscape && <WorldInfoDetails />}
    </div>
  )
}

export default WorldInfoPanel
